import { createSelector } from 'reselect'
import { selectPendingDowngrades } from './selectPendingDowngrades'

export const selectHasPendingDowngrade = createSelector(
  selectPendingDowngrades,
  pendingDowngrades => !!pendingDowngrades.kb || !!pendingDowngrades.inbox
)
